import { render, staticRenderFns } from "./VariationImage.vue?vue&type=template&id=bb97f860&"
import script from "./VariationImage.vue?vue&type=script&lang=js&"
export * from "./VariationImage.vue?vue&type=script&lang=js&"
import style0 from "./VariationImage.vue?vue&type=style&index=0&id=bb97f860&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports